exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-column[data-v-7e5dc5bc]{width:calc(100% + 15px);max-height:450px;overflow-y:auto}#home-panel-dropzone[data-v-7e5dc5bc]{min-height:126px}#home-panel-add-files[data-v-7e5dc5bc]{padding-top:40px}.dz-uploaded-file[data-v-7e5dc5bc]{cursor:default}.dropdown-menu.limited-height[data-v-7e5dc5bc]{max-height:250px;overflow-y:auto}@media (max-width:991px){.form-column[data-v-7e5dc5bc]{max-height:none}}", ""]);

// exports
